import React, { Component } from 'react'
import Review from './reviews'
import RestaurantSummary from '../restaurants/RestaurantSummary'
import { addFavorite2 } from '../../store/actions/restaurantActions'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { compose } from 'redux'

class Reviewer extends Component {

	constructor(props) {
	  super(props);
	  this.state = {
	  }
	}

onFavorite = (project) => {
  this.props.addFavorite2(project);
    };

distFinder=(restaurantId, distanceList)=>{
      const entries = Object.entries(distanceList);
      for (const entry of entries){
        if (entry[0] === restaurantId)
        return entry[1]
      }
      return ""
    };

openFinder = (project) => {
    //console.log(Object.keys(this.props.sortOptions.openList));
    for(let key in Object.keys(this.props.sortOptions.openList)){
      // console.log(key);
      // console.log(this.props.sortOptions.openList[key]['id']);
        if (project.restaurantId === this.props.sortOptions.openList[key]['id'] && this.props.sortOptions.openList[key]['isOpen']){
          //console.log(this.props.sortOptions.openList[key]['opensAt']);
          return(true);
        }
      }

    return(false)

  }

opensAtFinder = (project) => {
    //console.log(Object.keys(this.props.sortOptions.openList));
    for(var key2 in this.props.sortOptions.openList){
      //console.log(key2);
      //console.log(this.props.sortOptions.openList[key2]['id']);
        if (project.restaurantId === this.props.sortOptions.openList[key2]['id']){
          return(this.props.sortOptions.openList[key2]['opensAt']);
        }
      }
      return("error");
        
  }
  
render(){
	const { project } = this.props.location.state;
	const { auth, pendingReviews, points, user, favorites } = this.props;
	if (!auth.uid) return <Redirect to='/signin' />

return(
	<div>
	{ auth && pendingReviews && points && user && favorites &&
	<div>
	<h5 style={{"textAlign": "center"}}>Create a review for {project.name} </h5>
	<div className="messageContainer5" style={{"display":"flex","flexFlow":"column"}}>
	<div className="leftContainer">
		<div style={{"display": "flex", "justifyContent": "center"}}>
		<RestaurantSummary key = { project.restaurantId } allContent="" isOpen = {this.openFinder(project)} opensAt = {this.opensAtFinder(project)} distance = {this.distFinder(project.restaurantId, this.props.user.distanceList || "")} onFavorite = {this.onFavorite} project={project} favorite = {(project.restaurantId in {...favorites} && favorites[project.restaurantId].favorite === true )}/>
		</div>  
	</div>
	<div className="rightContainer">
		<div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
	    	<Review restaurantId={this.props.match.params.restaurantId} original={project}/>
	    </div>
    </div>
    </div>
	</div>
	}

	</div>
	)	
}

}

const mapStateToProps = (state) => {
	const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    pendingReviews: state.firestore.ordered.pendingReviews,
    points: state.firestore.data.points,
    favorites: state.firestore.data.favorites,
    sortOptions: state.restaurant.sortOptions,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addFavorite2: (project) => dispatch(addFavorite2(project))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reviewer)